import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import translationEN from '../assets/translations/en.json';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: translationEN,
    },
  },
  debug: true,
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: true,
  },
});
